const passengers = {
  table: {
    headers: {
      name: 'Name',
      email: 'Email',
      created: 'Date created',
      id: 'Id',
      profiles: 'Profiles Attached',
      createdBy: 'Created by',
      baseAddress: 'Home Address',
      occupationAddress: 'Work Address',
      createdAt: 'Created At',
      profile: 'Profile',
    },
  },
};

export default passengers;
